import { MarbleItem } from 'src/components/MarbleItem'
import { useMarblePositionLabel } from 'src/hooks/useMarblePositionLabel'
import { useClientSideTranslation } from 'src/services/i18n'
import { getTranslatedMarbleColor } from 'src/services/i18n/utils/gameTranslations'
import { useGetCurrentLanguage } from 'src/store/game'
import type { Marble } from 'src/types/domain/Marble'
import { getOrdinalSuffix } from 'src/utils/getOrdinalSuffix'
import Ellipsis from 'src/app/assets/icons/ico-ellipsis.svg'
import EllipsisAlt from 'src/app/assets/icons/ico-ellipsis-alt.svg'

type Props = Readonly<{
  position: number
  isRaceEnded: boolean
  exactOrder: boolean
  marble: Marble
  length: number
}>

export function BetHistorySelectedMarbles({
  isRaceEnded,
  exactOrder,
  position,
  marble,
  length
}: Props) {
  const { t } = useClientSideTranslation(useGetCurrentLanguage())
  const positionLabel = useMarblePositionLabel(position)
  const translatedColor = getTranslatedMarbleColor(marble.color, t)

  return (
    <div className="entry-order entry-order-marble-spin">
      <div className="entry-marble">
        <MarbleItem
          className={`marble-${marble.color}`}
          key={marble.uuid}
          marble={marble}
          tooltip={isRaceEnded ? `${translatedColor} -> ${positionLabel}` : undefined}
        />
      </div>
      {exactOrder ? (
        <div className="entry-selector">
          <div className={`select ${getOrdinalSuffix(position)} selected`}>{positionLabel}</div>
        </div>
      ) : (
        <div className="entry-selector">
          <div className="select">{length === 2 ? <EllipsisAlt /> : <Ellipsis />}</div>
        </div>
      )}
    </div>
  )
}
